/* ===== Le cadeau ne survit pas au produit payant (29 août 2026) =====
 *
 * ⛔ LE TROU. Le cadeau à 0 € de l'offre est une LIGNE DE PANIER ORDINAIRE, ajoutée à côté du
 * produit payant. Rien ne la retire quand le client enlève le produit payant du tiroir : il
 * restait donc un panier ne contenant QUE le cadeau, et le client pouvait aller au paiement avec
 * un article gratuit seul.
 *
 * LA RÈGLE, volontairement générale : dès qu'un panier ne contient plus AUCUNE ligne payante,
 * ses lignes à 0 € partent avec. Pas de liste d'identifiants à tenir à jour, pas de réglage par
 * boutique — un panier entièrement gratuit n'a aucune raison d'exister chez nous.
 *
 * ⚠️ ON N'OBSERVE PAS LE DOM. Un rattrapage par MutationObserver se redéclenche lui-même sur le
 * re-rendu qu'il provoque : la page ne finit jamais de charger (déjà vécu sur ce thème). On
 * s'accroche donc au SEUL endroit où le panier change vraiment : l'appel réseau.
 *
 * ⚠️ ET ON NE RE-RENDU RIEN À LA MAIN. On relance la modification avec les MÊMES sections que
 * celles demandées par le thème, et on rend CETTE réponse à sa place : c'est le thème qui
 * redessine, avec sa propre mécanique. Zéro DOM touché, zéro clignotement.
 */
(function () {
  'use strict';

  var MUTATION = /\/cart\/(change|update|clear)(\.js)?(\?|$)/;
  var fetchOrigine = window.fetch;
  if (typeof fetchOrigine !== 'function') return;

  var enCours = false; // ⛔ sans ça, notre propre appel se ré-intercepte à l'infini

  /** Le prix CATALOGUE de la ligne — AVANT toute remise.
   *
   *  ⛔ ON NE JUGE PAS SUR LE PRIX PAYÉ (constat de test, 29 août 2026). Une promo « 1 acheté =
   *  1 offert » met la deuxième ligne à 0 € payé alors qu'elle vaut 39,99 € au catalogue ; un code
   *  de réduction à 100 % ferait tomber TOUT le panier à zéro. Sur le prix payé, la règle aurait
   *  vidé le panier d'un client qui venait d'utiliser une promo — bien pire que le trou qu'on
   *  bouche. Le vrai cadeau, lui, est un produit dont le prix catalogue EST zéro. */
  function totalLigne(ligne) {
    if (typeof ligne.original_line_price === 'number') return ligne.original_line_price;
    if (typeof ligne.original_price === 'number') return ligne.original_price * (ligne.quantity || 0);
    return (ligne.price || 0) * (ligne.quantity || 0);
  }

  /** Les clés des lignes à 0 € — UNIQUEMENT s'il ne reste plus rien de payant. */
  function cadeauxOrphelins(panier) {
    if (!panier || !Array.isArray(panier.items) || !panier.items.length) return [];
    var gratuites = [];
    for (var i = 0; i < panier.items.length; i++) {
      if (totalLigne(panier.items[i]) > 0) return []; // une ligne payante suffit : on ne touche à rien
      gratuites.push(panier.items[i].key);
    }
    return gratuites;
  }

  function retirer(cles, sections) {
    var updates = {};
    for (var i = 0; i < cles.length; i++) updates[cles[i]] = 0;
    var corps = { updates: updates };
    if (sections) corps.sections = sections;
    enCours = true;
    return fetchOrigine('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(corps),
    }).then(function (r) {
      enCours = false;
      return r;
    }, function (e) {
      enCours = false;
      throw e;
    });
  }

  window.fetch = function (entree, init) {
    var url = typeof entree === 'string' ? entree : (entree && entree.url) || '';
    var promesse = fetchOrigine.apply(this, arguments);
    // ⛔ `add` est volontairement absent de MUTATION : un ajout ne peut pas rendre un cadeau
    // orphelin, et l'intercepter coûterait une lecture du panier à chaque clic « Ajouter ».
    if (enCours || !MUTATION.test(url)) return promesse;

    return promesse.then(function (reponse) {
      if (!reponse || !reponse.ok) return reponse;
      return reponse
        .clone()
        .json()
        .then(function (panier) {
          var cles = cadeauxOrphelins(panier);
          if (!cles.length) return reponse;

          // Les sections que le THÈME a demandées : sa réponse nous les donne, on rend
          // exactement la même forme pour qu'il redessine sans rien savoir de nous.
          var sections = panier.sections ? Object.keys(panier.sections).join(',') : null;

          return retirer(cles, sections).then(
            function (apres) {
              if (!apres || !apres.ok) return reponse;
              // Sans sections, le thème redessinerait l'état d'AVANT le retrait : le cadeau
              // resterait affiché alors qu'il n'est plus dans le panier. On recharge — c'est le
              // chemin rare (page /cart), et mieux vaut un rechargement qu'un panier qui ment.
              if (!sections) {
                try { window.location.reload(); } catch (e) { /* rien à faire de plus */ }
              }
              return apres;
            },
            function () { return reponse; }
          );
        })
        .catch(function () { return reponse; }); // réponse illisible → on ne casse jamais le panier
    });
  };

  /** Rafraîchit la pastille du panier — même geste que le thème dans sections/header.liquid.
   *  ⚠️ Une seule écriture DOM, ciblée, sans observateur : rien qui puisse se redéclencher. */
  function rafraichirPastille() {
    return fetchOrigine('/?sections=cart-icon-bubble', { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        if (!j || !j['cart-icon-bubble']) return;
        var t = document.createElement('div');
        t.innerHTML = j['cart-icon-bubble'];
        var w = t.querySelector('[id*="cart-icon-bubble"]') || t;
        document.querySelectorAll('#cart-icon-bubble').forEach(function (h) { h.innerHTML = w.innerHTML; });
      })
      .catch(function () { /* la pastille n'est qu'un affichage */ });
  }

  /* Panier déjà orphelin AVANT ce correctif — ou abandonné dans un autre onglet : on nettoie une
   * fois au chargement, sinon le client garderait indéfiniment son panier à 0 €.
   * ⛔ Pas de `reload()` ici : ce nettoyage tombe à l'ARRIVÉE sur la page, et recharger sous les
   * pieds du visiteur pour un panier qu'il ne regardait pas serait pire que le mal. On retire la
   * ligne et on remet la pastille d'aplomb, c'est tout ce qui se voit. */
  function nettoyageInitial() {
    fetchOrigine('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (panier) {
        var cles = cadeauxOrphelins(panier);
        if (cles.length) return retirer(cles, null).then(rafraichirPastille);
      })
      .catch(function () { /* silencieux : ce nettoyage ne doit jamais gêner la page */ });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', nettoyageInitial, { once: true });
  } else {
    nettoyageInitial();
  }
})();
